import type { ReactNode } from "react";
import { Tabs } from "@base-ui/react/tabs";

export function ShellTabs({
    value,
    onValueChange,
    tabs,
    children,
    ariaLabel,
}: {
    value: string;
    onValueChange: (value: string) => void;
    tabs: readonly { id: string; label: ReactNode; count?: number }[];
    children?: ReactNode;
    ariaLabel: string;
}) {
    return (
        <Tabs.Root value={value} onValueChange={next => onValueChange(String(next))} className="shell-tabs">
            <Tabs.List className="shell-tabs-list" aria-label={ariaLabel}>
                {tabs.map(tab => (
                    <Tabs.Tab key={tab.id} value={tab.id} className="shell-tab">
                        <span>{tab.label}</span>{tab.count != null && <small>{tab.count}</small>}
                    </Tabs.Tab>
                ))}
            </Tabs.List>
            {children}
        </Tabs.Root>
    );
}

export { Tabs as BaseTabs };
